import { useQueryParamsExecute } from "@relode/core";

import { ClientMarketResearchActions } from "./clientMarketResearchActions";
import {
    ClientMarketResearchState,
    defaultClientMarketResearchState,
} from "./clientMarketResearchState";

export const useClientMarketResearchSearchHandlers = (
    state: ClientMarketResearchState,
    actions: ClientMarketResearchActions
) => {
    useQueryParamsExecute(
        actions.updateMarketResearch,
        defaultClientMarketResearchState.searchCriteria
    );
};
